import * as React from "react";
import { PreJobCheckListV2Dialog, PreJobCheckListV2FormValues } from "./PreJobCheckListV2Dialog";
import { useToggle } from "../../hooks/useToggle";
import { Button, Typography } from "@material-ui/core";
import InspectionIcon from "@material-ui/icons/Assignment";
import { Contact } from "../../generated/nest-graphql";

type InspectionButtonType = {
  jobId: string;
  invoiceId: string;
  preJobCheckListInitialValues: PreJobCheckListV2FormValues;
  contact: Contact;
  disabled: boolean;
  text?: string;
};

export const OpenInspectionButtonV2 = ({
  jobId,
  invoiceId,
  preJobCheckListInitialValues,
  contact,
  disabled,
  text = "Inspect Vehicle",
}: InspectionButtonType) => {
  const [inspectionOpen, , toggleInspection] = useToggle();
  return (
    <>
      <Button
        // disabled={disabled}
        className="w-1/2"
        variant={"contained"}
        color={"secondary"}
        onClick={toggleInspection}
      >
        <div>
          <InspectionIcon />
          <Typography display={"block"} variant={"caption"}>
            {text}
          </Typography>
        </div>
      </Button>
      <PreJobCheckListV2Dialog
        onClose={toggleInspection}
        jobId={jobId}
        invoiceId={invoiceId}
        open={inspectionOpen}
        initialValues={preJobCheckListInitialValues}
        isReadOnly={disabled}
      />
    </>
  );
};
